export default "__VITE_PUBLIC_ASSET__dbb6322e__"